import { Stack, Typography } from '@mui/material';

import { AddIcon } from '~assets/icons';
import { STATION_TYPE } from '~common';
import { StationPlacementType } from '~types/venue-placement.type';
import { getStationInfoDisplay } from '~utils/station.util';

type Props = {
  placement: StationPlacementType;
  onClick: (placement: StationPlacementType) => void;
  selectedPlacementId?: string;
  disabled?: boolean;
};

export const PlacementListCard: React.FC<Props> = ({
  placement,
  onClick,
  selectedPlacementId,
  disabled,
}) => {
  const isSelected = selectedPlacementId === placement.id;

  return (
    <Stack
      direction="row"
      alignItems="flex-start"
      spacing={2}
      role="button"
      tabIndex={0}
      onClick={() => !disabled && onClick(placement)}
      sx={{
        width: '100%',
        p: 2,
        border: '1px solid',
        borderColor: isSelected && !disabled ? 'primary.main' : 'grey.300',
        borderRadius: 2,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
        '&:hover': {
          backgroundColor: disabled ? undefined : 'grey.50',
        },
      }}
    >
      {placement.type === undefined ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{
            width: 56,
            height: 56,
            backgroundColor: '#F3F4F6',
            border: '1px solid #E5E7EB',
            borderRadius: 1,
            flexShrink: 0,
          }}
        >
          <AddIcon />
        </Stack>
      ) : (
        <img
          src={getStationInfoDisplay(placement.type as STATION_TYPE).imageUrl}
          alt="station"
          width={56}
          height={56}
          style={{
            backgroundColor: '#EFF2F6',
            borderRadius: 8,
            flexShrink: 0,
          }}
        />
      )}

      <Stack spacing={0.5}>
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{ lineHeight: '24px' }}
        >
          {placement.name}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: '20px' }}
        >
          {placement.placementType ?? '---'}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: '20px' }}
        >
          ID: {placement.externalId ?? '---'}
        </Typography>

        {placement.type && placement.imei && (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ lineHeight: '20px' }}
          >
            IMEI: {placement.imei}
          </Typography>
        )}

        {disabled && (
          <Typography
            color="text.placeholder"
            variant="body2"
            fontWeight="bold"
          >
            This placement has already been selected!
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};
